import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-notification-banner-card',
  standalone: false,
  templateUrl: './notification-banner-card.component.html',
  styleUrls: ['./notification-banner-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationBannerCardComponent {
  @Input() title = '';
  @Input() message = '';
}
